import 'whatwg-fetch';
import {Controller} from 'stimulus';
import StripePaymentRequest from '../components/stripe_payment_request/stripe_payment_request';
import StripeInitializer from '../components/stripe_initializer/stripe_initializer';

export default class extends Controller {
    connect() {
        this.stripeForm = document.getElementById(this.element.id);
        this.formButton = document.querySelector('.SubscriptionInputForm-submit');
        this.radioButtonTrue = document.getElementById('radioButtonTrue');
        this.radioButtonFalse = document.getElementById('radioButtonFalse');
        if (!window.location.href.includes('&show_payment_box') && this.radioButtonTrue && this.radioButtonFalse) {
            this.formButton.disabled = true;
        }

        window.addEventListener('paymentReady', (event) => {
            this.processForm(event.detail.payment_method_id, event.detail.button);
        });

        StripeInitializer.load(window.stripe_api_key_url)
            .then((stripeObject) => {
                this.stripeObject = stripeObject;
                this.stripeElements = stripeObject.elements();

                this.initializePaymentRequest();
            })
            .catch((error) => {
                if (window.dtrum && typeof window.dtrum.reportError === 'function') {
                    window.dtrum.reportError(`Error initializing payment request in subscription_input_form_controller: ${error}`);
                }
            });
    }

    initializePaymentRequest() {
        const paymentRequestButton = document.getElementById(
            'payment-request-button'
        );
        if (
            paymentRequestButton &&
            window.clientSecret &&
            window.productName
        ) {
            /* eslint-disable no-new */
            new StripePaymentRequest(
                this.stripeObject,
                this.stripeElements,
                this.processForm.bind(this),
                paymentRequestButton,
                window.clientSecret,
                window.invoiceAmount,
                window.productName,
                window.trial_end_date,
                window.recurring_amount,
                window.recurring_interval,
            );
        }
    }

    submitNoPaymentForm(event) {
        event.target.disabled = true;
        this.stripeForm.submit();
    }

    togglePaymentRequired(e) {
        e.preventDefault();
        if (e.target.value === 'true') {
            if (window.location.href.includes('&show_payment_box=false')) {
                window.location.href = window.location.href.replace('&show_payment_box=false', '&show_payment_box=true');
            } else {
                window.location.href += '&show_payment_box=true';
            }
        } else {
            if (window.location.href.includes('&show_payment_box=true')) {
                window.location.href = window.location.href.replace('&show_payment_box=true', '&show_payment_box=false');
            } else {
                this.formButton.disabled = false;
            }
        }
    }

    setPaymentIdInput(id) {
        let paymentMethodIdInput = document.querySelector(
            `#${this.element.id} input[name='payment_method_id']`
        );
        paymentMethodIdInput.setAttribute('value', id);
    }

    processForm(paymentId, buttonElement) {
        if (buttonElement) {
            buttonElement.disabled = true;
        }
        this.setPaymentIdInput(paymentId);
        this.stripeForm.submit();
    }
}
